import React from 'react'

//@ts-ignore
import RSelect from 'react-select'
import CustomOptions from './CustomOptions'
import Control from './Control'

export const Select: React.FC = (props: any) => {
  return <RSelect components={{ Option: CustomOptions, Control }} {...props} />
}
